export enum PopupType {
  DYNAMIC = 'DYNAMIC',
  AUTH = 'AUTH',
  PLAYER_PREVIEW = 'PLAYER_PREVIEW',
}

export type DynamicPopupButton = {
  text: string;
  link?: string;
  analytics?: {
    action: string;
    label: string;
  };
  callback?: () => void;
  theme?: 'primary' | 'secondary' | 'bordered' | 'outlined';
  isContinueButton?: boolean;
}

export type DynamicPopupStep = {
  title: string;
  description: string;
  hasBackButton?: boolean;
  image?: string;
  buttons?: DynamicPopupButton[];
}

export type DynamicPopupMeta = {
  steps: DynamicPopupStep[];
}
// Определяем мету для каждого типа попапа
export interface PopupMetaMap {
  [PopupType.DYNAMIC]: DynamicPopupMeta;
  [PopupType.AUTH]: null;
  [PopupType.PLAYER_PREVIEW]: null;
}
